(function () {
var $f96411e1ca11d324$exports = {};
if (null) null.accept();
const $f96411e1ca11d324$var$mapContainer = document.getElementById("map");
const $f96411e1ca11d324$var$ipAddress = document.querySelector(".ipAddress");
const $f96411e1ca11d324$var$locationEl = document.querySelector(".location");
const $f96411e1ca11d324$var$timezone = document.querySelector(".timezone");
const $f96411e1ca11d324$var$isp = document.querySelector(".isp");
const $f96411e1ca11d324$var$input = document.querySelector("input");
const $f96411e1ca11d324$var$send = document.querySelector(".send");
const $f96411e1ca11d324$var$ipAddressContainer = document.querySelector(".ip--container");
const $f96411e1ca11d324$var$locationContainer = document.querySelector(".location--container");
const $f96411e1ca11d324$var$timezoneContainer = document.querySelector(".timezone--container");
const $f96411e1ca11d324$var$ispContainer = document.querySelector(".isp--container");
const $f96411e1ca11d324$var$container = document.querySelector(".displayed--information--container");
let $f96411e1ca11d324$var$paragraph = document.querySelector(".errormsg");
let $f96411e1ca11d324$var$popup = "Your current location\uD83D\uDCCC";
let $f96411e1ca11d324$var$lat;
let $f96411e1ca11d324$var$lng;
const $f96411e1ca11d324$var$validIpTest = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const $f96411e1ca11d324$var$validDomainTest = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
const $f96411e1ca11d324$var$executeCode = ()=>{
    // remove the container hidden classes
    $f96411e1ca11d324$var$ipAddressContainer.classList.add("hidden");
    $f96411e1ca11d324$var$locationContainer.classList.add("hidden");
    $f96411e1ca11d324$var$timezoneContainer.classList.add("hidden");
    $f96411e1ca11d324$var$ispContainer.classList.add("hidden");
    $f96411e1ca11d324$var$paragraph.classList.add("hidden");
    $f96411e1ca11d324$var$container.classList.remove("h-[100px]");
    const value = $f96411e1ca11d324$var$input.value;
    if (!value) return;
    if ($f96411e1ca11d324$var$validIpTest.test(value)) $f96411e1ca11d324$var$fetchData(value, "");
    else if ($f96411e1ca11d324$var$validDomainTest.test(value)) $f96411e1ca11d324$var$fetchData("", value);
    else {
        $f96411e1ca11d324$var$input.style.border = "1px solid red";
        let value = $f96411e1ca11d324$var$input.value;
        $f96411e1ca11d324$var$input.value = "Please enter a valid ip address or domain name";
        $f96411e1ca11d324$var$input.style.color = "red";
        setTimeout(()=>{
            $f96411e1ca11d324$var$input.style.border = "none";
            $f96411e1ca11d324$var$input.value = value;
            $f96411e1ca11d324$var$input.style.color = "black";
        }, 3000);
        return;
    }
};
$f96411e1ca11d324$var$send.addEventListener("click", $f96411e1ca11d324$var$executeCode);
document.addEventListener("keydown", (e)=>{
    if (e.key === "Enter") $f96411e1ca11d324$var$executeCode();
});
const $f96411e1ca11d324$var$type = new Typed(".auto-type", {
    strings: [
        "please wait...",
        "hang tight!",
        "almost there..."
    ],
    typeSpeed: 100,
    backSpeed: 100,
    loop: true
});
const $f96411e1ca11d324$var$fetchData = async (value, domain)=>{
    try {
        document.querySelector(".loading-element").classList.remove("hidden");
        const baseURL = "https://geo.ipify.org/api/v2/country,city";
        const apiKey = "at_tJ66XQzhcu490QC72T4T9hFmh1IrV"; // Secure this key in backend
        const queryParams = value ? `&ipAddress=${value}` : domain ? `&domain=${domain}` : "";
        const res = await fetch(`${baseURL}?apiKey=${apiKey}${queryParams}`);
        if (!res.ok) throw new Error(`API Error: ${res.status} ${res.statusText}`);
        const data = await res.json();
        console.log("API Response:", data); // Debugging
        if (!data.location || typeof data.location.lat !== "number" || typeof data.location.lng !== "number") {
            console.error("Invalid location data", data);
            $f96411e1ca11d324$var$paragraph.textContent = "Location data not available. Please check the input.";
            $f96411e1ca11d324$var$paragraph.classList.remove("hidden");
            return;
        }
        $f96411e1ca11d324$var$ipAddressContainer.classList.remove("hidden");
        $f96411e1ca11d324$var$locationContainer.classList.remove("hidden");
        $f96411e1ca11d324$var$timezoneContainer.classList.remove("hidden");
        $f96411e1ca11d324$var$ispContainer.classList.remove("hidden");
        $f96411e1ca11d324$var$ipAddress.textContent = data.ip;
        $f96411e1ca11d324$var$locationEl.textContent = `${data.location.city}, ${data.location.country}`;
        $f96411e1ca11d324$var$timezone.textContent = `UTC${data.location.timezone}`;
        $f96411e1ca11d324$var$isp.textContent = data.isp;
        $f96411e1ca11d324$var$popup = `${data.location.city}, ${data.location.country} \u{1F4CC}`;
        $f96411e1ca11d324$var$lat = data.location.lat;
        $f96411e1ca11d324$var$lng = data.location.lng;
        $f96411e1ca11d324$var$mapFunction($f96411e1ca11d324$var$lat, $f96411e1ca11d324$var$lng);
    } catch (err) {
        console.error("Something went wrong:", err.message);
        $f96411e1ca11d324$var$paragraph.textContent = err.message;
        $f96411e1ca11d324$var$paragraph.classList.remove("hidden");
    } finally{
        document.querySelector(".loading-element").classList.add("hidden");
    }
};
let $f96411e1ca11d324$var$map = null;
let $f96411e1ca11d324$var$mapInitialized = false;
let $f96411e1ca11d324$var$marker;
const $f96411e1ca11d324$var$mapFunction = (lat, lng)=>{
    if ($f96411e1ca11d324$var$mapInitialized ? null : $f96411e1ca11d324$var$mapInitialized = true) {
        $f96411e1ca11d324$var$map = L.map($f96411e1ca11d324$var$mapContainer).setView([
            lat,
            lng
        ], 15);
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo($f96411e1ca11d324$var$map);
        $f96411e1ca11d324$var$mapInitialized = true;
    } else $f96411e1ca11d324$var$map.setView([
        lat,
        lng
    ], 15);
    if ($f96411e1ca11d324$var$marker) $f96411e1ca11d324$var$map.removeLayer($f96411e1ca11d324$var$marker);
    $f96411e1ca11d324$var$marker = L.marker([
        lat,
        lng
    ]).addTo($f96411e1ca11d324$var$map).bindPopup($f96411e1ca11d324$var$popup).openPopup();
};
navigator.geolocation.getCurrentPosition((position)=>{
    let { latitude: latitude, longitude: longitude } = position.coords;
    $f96411e1ca11d324$var$mapFunction(latitude, longitude);
    $f96411e1ca11d324$var$mapInitialized || ($f96411e1ca11d324$var$mapInitialized = true);
}, (error)=>{
    console.log("something went wrong", error);
});

})();
//# sourceMappingURL=index.d7f1c92d.js.map
